import {actionTypes} from './constants'

export const fetchLeads = ({limit=100, skip=0}={}) => ({
  type: actionTypes.FETCH_LEADS_REQUESTED,
  payload: {
    limit,
    skip,
  },
})
